import { useRef } from 'react';

/** A fresh baseline per editor identity/open cycle, stable during background refreshes.
 * Missing data may initialize the session later. Pass null to end the session.
 * Authority must always come from current trusted data, never this snapshot.
 */
export function useEditorSession<T>(
  identity: string | null,
  source: T | null,
): T | null {
  const session = useRef<{ identity: string | null; baseline: T | null }>({
    identity: null,
    baseline: null,
  });
  if (session.current.identity !== identity)
    session.current = { identity, baseline: source };
  if (identity === null) session.current.baseline = null;
  else if (session.current.baseline === null && source !== null)
    session.current.baseline = source;
  return session.current.baseline;
}
